module.exports = __webpack_public_path__ + "img/38.003a95ba.jpg";